Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.ExportableChart extends Backbone.View

  events:
    'mouseover': 'onMouseOver'
    'mouseout': 'onMouseOut'

  onMouseOver: =>
    @$el.find(".highcharts-button").css('display', 'inherit')

  onMouseOut: =>
    @$el.find(".highcharts-button").css('display', 'none')